<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表-退款
  -->
  <el-dialog title="退款" width="840px" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="refund">
      <div class="refund_item">
          <div class="item">扣空单费用</div>
          <div class="item_name">技师出发前，用户取消可以扣除<span class="red">10元</span>空单费用（技师没有收益）</div>
      </div>
      <div class="refund_item">
          <div class="item">扣路程费用</div>
          <div class="item_name">技师出发后到达前，用户取消可以扣<span class="red">10.24元</span>车费+<span class="red">10元</span>空单费用（技师收益10.24元）</div>
      </div>
      <div class="refund_item">
          <div class="item">部分退款</div>
          <div class="item_name">可以扣除部分费用（可赔付给用户）</div>
      </div>
      <div class="refund_item">
          <div class="item">全部退款</div>
          <div class="item_name">接单以后可以全部退款（技师收益10.24元）</div>
      </div>
    </div>
    <el-form size="small" :model="orderFrom">
      <el-form-item label="退款金额" :label-width="formLabelWidth"  prop="pay_money" :rules="[{required: true,message: ' '}]">
        <span>{{ orderFrom.pay_money }}元</span>
        <span>（可退款{{ orderFrom.pay_money }}元）</span>
      </el-form-item>    
      <el-form-item label="订单状态" :label-width="formLabelWidth"  prop="order" :rules="[{required: true,message: ' '}]">
        <span>{{ orderFrom.order }}</span>
      </el-form-item>    
      <el-form-item label="已退款金额" :label-width="formLabelWidth"  prop="refund_money" :rules="[{required: true,message: ' '}]">
        <span>{{ orderFrom.refund_money }}元</span>
      </el-form-item>    
      <el-form-item label="技师收入" :label-width="formLabelWidth"  prop="income" :rules="[{required: true,message: ' '}]">
        <span>{{ orderFrom.income }}元</span>
      </el-form-item>    
      <el-form-item label="退款金额" :label-width="formLabelWidth"  prop="money" :rules="[{required: true,message: '请输入退款金额'}]">
        <el-input v-model="orderFrom.money" autocomplete="off" placeholder="请输入退款金额"></el-input>
        <span style="color:#ccc">请输入您的退款金额，不能大于支付金额</span>
      </el-form-item>
      <el-form-item label="备注" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="orderFrom.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser(form.user_id)" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        loading: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        orderFrom:{
          pay_money:'507.24',
          order:'评价',
          refund_money:'0.00',
          income:'251.98',
          money:'0',
          remark:''
        }
      };
    },
    props: ['open_add', 'form'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*充值*/
      addUser(e) {
        let self = this;
        self.dialogFormVisible(true);
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style lang="scss" scoped>
.refund{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .refund_item{
    height: 80px;
    width: 48%;
    border-radius: 16px;
    background: #eee;
    position: relative;
    margin: 20px 0;
    .item{
      position: absolute;
      top: 0;
      left: 0;
      padding: 4px 10px;
      border-radius: 16px 0 16px 0;
      background: #666;
      color: #fff;
      font-weight: bold;
    }
    .item_name{
      position: absolute;
      left: 23px;
      right: 23px;
      top:36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Recharge.vue